/**
 * 관리자(admin) 레이아웃 전역 초기화.
 * 폼, 테이블, 드로어, 알림 등 관리자 전용 모듈을 초기화한다.
 */
import { showFlashToasts } from "../utils/Toast";
import {
    initTagPickers,
    initAdminDateTimeInputs,
    initAdminFlatpickrPickers,
    initAdminSelects,
    initTagInputs,
    initNumberSteppers,
    initCharCounters,
    initAdminSearchBars,
    initIntlPhoneInputs,
    initCountrySelects,
    initLocaleSelects,
    initFileUploaders,
    initAdminLayoutDrawer,
    initAdminBreadcrumb,
    initAdminHeaderNav,
    initAdminDrawerSearch,
    initAdminNotificationsDropdown,
    initAdminNotificationsUnreadPoll,
    initAutoSubmitSelects,
    initAdminUserDestroyButtons,
    initAdminConfirmRedirectForms,
    initBulkSelect,
    initPageMove,
    initAdminThemeToggle,
    initAdminFontScale,
    initPasswordToggles,
    initAnalyticsExcludedIp,
    initAccessControl,
    initAdminEntityPicker,
    initAdminCalendarFilter,
    bindForms,
    initFormWrapper,
} from "../admin/global";
import { initOpsConsole, initOpsTabs } from "../admin/pages/OpsConsole";
import { initSourceProtectionRelease } from "../admin/pages/SourceProtectionRelease";
import { initContentBlockTypeToggle } from "../admin/pages/ContentBlockForm";
import { initPageTree } from "../admin/components/PageTreeSortable";
import { initPageBlockBuilder } from "../admin/components/PageBlockBuilder";
import { initPageFormModal } from "../admin/components/PageFormModal";
import { initCmsMenuTree } from "../admin/components/CmsMenuTree";
import { initCmsFormModal } from "../admin/components/CmsMenuItemModal";
import { initCmsContentSort } from "../admin/components/CmsContentSort";
import { initCmsDesignVariablesPanel } from "../admin/components/CmsDesignVariablesPanel";
import { initCmsSiteBuilder } from "../admin/components/CmsSiteBuilder";
import { initCmsSiteEditor } from "../admin/components/CmsSiteEditor";
import { ListingTable } from "../admin/components/ListingTable";
import { CardTable } from "../admin/components/CardTable";
import { LocaleTabs } from "../admin/components/LocaleTabs";
import { IndexLocaleSwitch } from "../admin/components/IndexLocaleSwitch";
import { RichEditor } from "../components/RichEditor";
import { initAdminFormControls } from "../admin/global/initAdminFormControls";
import { initAdminTooltips } from "../admin/components/AdminTooltip";
import { initPopupForm } from "../admin/popup/PopupForm";

export class AdminLayout {
    static init(): void {
        showFlashToasts();
        initFormWrapper();
        initTagPickers(document);
        // 폼 컨트롤(셀렉트·태그·날짜·업로더·언어탭·리치에디터·엔티티피커)은 모달과 공유하는
        // 헬퍼로 일괄 init — 페이지/모달 초기화가 갈라지지 않도록 단일 소스로 유지.
        initAdminFormControls();
        initAdminTooltips();
        // 동적으로 추가되는 폼 요소(예: 세트구성 "+ 메뉴 추가")에서 호출할 수 있도록 노출
        (window as unknown as { AdminUI: Record<string, unknown> }).AdminUI = {
            bindForms,
            initAdminSelects,
            initNumberSteppers,
            initTagInputs,
            initCharCounters,
        };
        initAdminSearchBars();
        initIntlPhoneInputs();
        initCountrySelects();
        initLocaleSelects();
        initAdminLayoutDrawer();
        initAdminBreadcrumb();
        initAdminHeaderNav();
        initAdminDrawerSearch();
        initAdminNotificationsDropdown();
        initAdminNotificationsUnreadPoll();
        initAutoSubmitSelects();
        initAdminUserDestroyButtons();
        initAdminConfirmRedirectForms();
        initBulkSelect();
        initPageMove();
        initAdminThemeToggle();
        initAdminFontScale();
        initOpsConsole();
        initOpsTabs();
        initSourceProtectionRelease();
        initContentBlockTypeToggle();
        initPageTree();
        initPageBlockBuilder();
        initPageFormModal();
        initCmsMenuTree();
        initCmsFormModal();
        initCmsContentSort();
        initCmsDesignVariablesPanel();
        initCmsSiteBuilder();
        initCmsSiteEditor();
        ListingTable.initAll();
        CardTable.initAll();
        IndexLocaleSwitch.initAll();
        initPasswordToggles();
        initAnalyticsExcludedIp();
        initAccessControl();
        initAdminCalendarFilter();
        initPopupForm();
    }
}
